import React from 'react'
import PropTypes from 'prop-types'
import { withCookies } from 'react-cookie'
import { ApolloProvider as ApolloHooksProvider } from '@apollo/client'
import uuidGenerator from 'uuid/v1'
import config from 'config'

import { getApolloClient } from '@cred/shared/apollo'

const withApolloProvider = (WrappedComponent) => {
  let apolloClient

  const WithApolloProvider = (props) => {
    const { cookies } = props

    const handleRedirect = (url) => {
      window.location.href = url
    }

    if (!apolloClient) {
      apolloClient = getApolloClient(cookies, {
        uri: config.graphqlUri,
        headers: {
          'session-id': uuidGenerator(),
        },
        redirect: (url) => handleRedirect(url),
        apq: config.apq,
      })
    }

    return (
      <ApolloHooksProvider client={apolloClient}>
        <WrappedComponent {...props} />
      </ApolloHooksProvider>
    )
  }

  WithApolloProvider.propTypes = {
    cookies: PropTypes.object.isRequired,
  }

  return withCookies(WithApolloProvider)
}

export default withApolloProvider
